import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-glass-water",
  "use": "icon-si-glyph-glass-water-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-glass-water\" id=\"icon-si-glyph-glass-water\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>875</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M1.365,12.336 L4.66,15.639 C5.138,16.118 5.902,16.123 6.373,15.654 L16.624,7.932 C17.092,7.463 17.086,6.696 16.61,6.219 L10.765,0.364 C10.289,-0.113 9.523,-0.119 9.054,0.35 L1.351,10.622 C0.881,11.092 0.889,11.859 1.365,12.336 L1.365,12.336 Z M7.336,9.772 C5.746,9.78 3.982,8.525 3.982,8.525 L6.659,5.095 L9.318,1.687 C9.764,1.248 10.495,1.255 10.949,1.701 L15.342,6.024 C15.796,6.471 15.801,7.19 15.354,7.628 L10.789,11.056 C10.788,11.057 9.189,9.763 7.336,9.772 L7.336,9.772 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-glass-water.svg
// module id = 3t1d
// module chunks = 62